import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import { createUsersgeneral } from "../../../domain/api/UsersApi";
import { useDispatch } from "react-redux";
import { Store } from "react-notifications-component";

const roles = [
  { label: "Admin", value: "ROLE_ADMIN" },
  { label: "Usuario", value: "ROLE_USER" },
  { label: "Cliente", value: "ROLE_CLIENT" },
  { label: "Soporte", value: "ROLE_SUPPORT" },


];

const validationSchema = yup.object().shape({
  nombre: yup.string().required("Por favor ingresa un nombre"),
  telefono: yup.string().required("Por favor ingresa un teléfono"),
  email: yup.string().email("Ingresa un email válido").required("Por favor ingresa un email"),
  username: yup.string().required("Por favor ingresa un nombre de usuario"),
  password: yup.string().required("Por favor ingresa una contraseña").matches(/^(?=.*[a-zA-Z])(?=.*[0-9])/, "La contraseña debe contener letras y números")
});
const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '20px',
    backgroundColor: 'white',
    color: '#2196F3',
    padding: '16px',
    display: 'flex',
    justifyContent: 'Center',
    alignItems: 'center',
    fontWeight: 'bold'
  },
}));
const CreateUserModal = ({ reload, clearData, primaryColor }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispath = useDispatch();
  const classes = useStyles();
  const handledAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    });
    setTimeout(() => {
      setIsLoading(false);
      reload();
      clearData();
    }, 1000);
  }

  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const request = {
      name: values.nombre,
      phone: values.telefono,
      email: values.email,
      username: values.username,
      rol: values.rol,
      password: values.password,
    };


    const response = await createUsersgeneral(dispath, request)
    try {
      if (response.success) {
        handledAlert("Creado Exitosamente!", `Usuario ${values.nombre} creado con exito!`, "success")
      } else {
        handledAlert("Ocurrio un error al crear el usuario!" || "Error interno", "danger")
      }
    } catch {
      handledAlert("Ocurrio un erro!", "Error interno", "danger")
    }


    setTimeout(() => {
      setIsLoading(false);
      resetForm();
      reload(); // Llama a la función de recarga pasada como prop
      clearData(); // Llama a la función para cerrar el modal pasada como prop
    }, 2000);
  };



  return (
    <Dialog open={true} onClose={clearData}>
      <DialogTitle className={classes.title} style={{ color: primaryColor }}>Crear Usuario</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            nombre: "",
            telefono: "",
            email: "",
            username: "",
            rol: "",
            password: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="nombre">Nombre</InputLabel>
                    <OutlinedInput
                      type="nombreedit"
                      id="nombre"
                      name="nombre"
                      value={values.nombre}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={60}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.nombre && errors.nombre && <div style={{ color: "red" }}>{errors.nombre}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="telefono">Teléfono</InputLabel>
                    <OutlinedInput
                      type="celedit"
                      id="telefono"
                      name="telefono"
                      value={values.telefono}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={75}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.telefono && errors.telefono && <div style={{ color: "red" }}>{errors.telefono}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <OutlinedInput
                      type="nombreedit"
                      id="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={60}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.email && errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="username">Nombre de usuario</InputLabel>
                    <OutlinedInput
                      type="nombreedit"
                      id="username"
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={60}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.username && errors.username && <div style={{ color: "red" }}>{errors.username}</div>}
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="rol">Rol</InputLabel>
                    <Select
                      id="rol"
                      name="rol"
                      value={values.rol}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={30}
                      style={{ borderRadius: '10px' }}
                    >
                      {roles.map((role) => (
                        <MenuItem key={role.value} value={role.value}>
                          {role.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="password">Contraseña</InputLabel>
                    <OutlinedInput
                      type="password"
                      id="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      labelWidth={60}
                      style={{ borderRadius: '10px' }}
                    />
                  </FormControl>
                  {touched.password && errors.password && <div style={{ color: "red" }}>{errors.password}</div>}
                </Grid>
              </Grid>
              <DialogActions>
                <Button type="submit" color="primary" disabled={isLoading}>
                  {isLoading ? "Creando..." : "Crear Usuario"}
                </Button>
                <Button onClick={clearData} color="primary">
                  Cancelar
                </Button>
                {isLoading && <CircularProgress size={24} />}
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default CreateUserModal;